import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SpriSplashScreenService {
  private document = inject(DOCUMENT);
  private router = inject(Router);

  /**
   * Constructor
   */
  constructor() {
    // Hide it on the first NavigationEnd event
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        take(1)
      )
      .subscribe(() => {
        this.hide();
      });
  }

  /**
   * Show the splash screen
   */
  public show(): void {
    this.document.body.classList.remove('spri-splash-screen-hidden');
  }

  /**
   * Hide the splash screen
   */
  public hide(): void {
    this.document.body.classList.add('spri-splash-screen-hidden');
  }
}
